import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Grid,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

const ExtrasPanel = ({
  open,
  onClose,
  onSelect,
  title,
  subtitle,
  type,
}) => {
  const { t } = useTranslation()

  const handleNumberSelect = useCallback((number) => {
    try {
      onSelect(number)
      onClose()
    } catch (error) {
      console.error('Error selecting number:', error)
    }
  }, [onSelect, onClose])

  const handleKeyDown = useCallback((event, number) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      handleNumberSelect(number)
    }
  }, [handleNumberSelect])

  const handleDialogKeyDown = useCallback((event) => {
    if (event.key === 'Escape') {
      onClose()
    }
  }, [onClose])

  return (
    <Dialog
      open={open}
      onClose={onClose}
      onKeyDown={handleDialogKeyDown}
      maxWidth="xs"
      fullWidth
      aria-labelledby="extras-panel-title"
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: 2,
        }
      }}
    >
      <DialogTitle id="extras-panel-title" sx={{ pb: 1 }}>
        <Typography variant="h6" component="div">
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            {subtitle}
          </Typography>
        )}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <Grid container spacing={1}>
            {[1, 2, 3, 4, 5, 6].map((number) => (
              <Grid size={4} key={number}>
                <Button
                  fullWidth
                  variant="outlined"
                  size="large"
                  onClick={() => handleNumberSelect(number)}
                  onKeyDown={(e) => handleKeyDown(e, number)}
                  sx={{
                    minHeight: 56,
                    fontSize: '1.5rem',
                    fontWeight: 600,
                    textTransform: 'none',
                    borderWidth: 2,
                    '&:hover': {
                      borderWidth: 2,
                    }
                  }}
                  role="button"
                  tabIndex={0}
                  aria-label={`Select ${number} runs`}
                >
                  {number}
                </Button>
              </Grid>
            ))}
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          size="medium"
          sx={{ textTransform: 'none' }}
        >
          {t('common.cancel', '取消')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

ExtrasPanel.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  type: PropTypes.string.isRequired,
}

export default ExtrasPanel
